import { useEffect, useState } from "react";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import { setLanguageChangeFlag, stopPlayingAudio, triggerPwaInstall, playAudio, isNeGDDeployment } from "../../../Actions/Utils";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import { languageLabel } from "../../../NewConstants/Language-Constants";
import { pwaInstallButton, pwaInstallCancel, pwaInstallHeading } from "../../../NewConstants/PwaInstallConstants";
import { useNavigate } from "react-router-dom";
import { guideButtons } from "../../../NewConstants/IntroductionConstants";

const PwaInstall = ({ selectedLanguage, audioRef }) => {
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (showSpeakerActive) {
      const filePath = `/Assets/Sounds/InstallPWAPage/${selectedLanguage}_install.mp3`;
      playAudio(filePath, audioRef, () => setShowSpeakerActive(false));
    } else {
      stopPlayingAudio(audioRef);
    }
  }, [showSpeakerActive, selectedLanguage, audioRef]);

  const handleLanguageChange = () => {
    setLanguageChangeFlag("false");
    stopPlayingAudio(audioRef);
    navigate("/lang");
  };

  const navigateToNextScreen = () => {
    stopPlayingAudio(audioRef);
    navigate(isNeGDDeployment() ? "/app-error" : "/login");
  };

  const handleInstallPwa = async () => {
    stopPlayingAudio(audioRef);
    setShowSpeakerActive(false);
    const result = await triggerPwaInstall();
    
    if (result.success) {
      // PWA was installed successfully, navigate to next screen
      navigateToNextScreen();
    } else if (result.outcome === 'dismissed') {
      // User dismissed the install prompt, still navigate forward
      navigateToNextScreen();
    } else {
      // No prompt available or error occurred - show error and wait so user can read it
      setToastErrorMessage("Unable to install app. Please try from browser menu.");
      setShowToastMessage(true);
      setTimeout(() => {
        navigateToNextScreen();
      }, 2000);
    }
  };

  const handleSkipInstall = () => {
    stopPlayingAudio(audioRef);
    navigateToNextScreen();
  };

  return (
    <div
      style={{
        overflow: "scroll",
        backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")`,
      }}
      className="bg-[var(--primary-dark-2)] h-screen w-screen relative bg-blend-color-burn flex items-center justify-center px-4"
    >
      <div className="w-[100%] rounded-2xl bg-white  p-0 flex flex-col max-w-[20.125rem]">
        {/* Speaker button at top right */}
        <div className="h-[4rem] w-full flex justify-between items-center px-2">
            <div className="flex items-center" onClick={isNeGDDeployment() ? undefined : handleLanguageChange}>
                <img src={isNeGDDeployment() ? "/Assets/Images/GlobeRed.svg" : "/Assets/Images/GlobeBlue.svg"} alt="globe" className="w-5 h-5 mr-2"/>
                <span className="text-[color:var(--primary-dark)] font-bold text-md">{languageLabel[selectedLanguage] || ""}</span>
                <svg className="ml-2 w-4 h-4" fill="none" stroke="var(--primary-dark)" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
            </div>
          <div className="h-[3rem] flex justify-end items-center">
            {/* <SpeakerChatBlock /> */}
            <div
              className={`flex justify-end items-center 
              ${
                showSpeakerActive
                  ? isNeGDDeployment()
                    ? "bg-[var(--red-5)] pl-4 rounded-[23px] [color:var(--black)]"
                    : "bg-[var(--active-speaker-div)] pl-4 rounded-[23px] [color:var(--black)]"
                  : ""
              }`}
              onClick={() => {
                setShowSpeakerActive((prev) => !prev);
              }}
            >
              {showSpeakerActive ? guideButtons.stop[selectedLanguage] : null}
              {showSpeakerActive ? (
                <div className="">
                  <img
                    src={
                      isNeGDDeployment()
                        ? "/Assets/Images/RedSpeaker.svg"
                        : "/Assets/Images/blueSpeaker.svg"
                    }
                    alt="active Speaker"
                    className="w-10 h-10"
                  />
                </div>
              ) : (
                <div className="">
                  <img
                    src={"/Assets/Images/crossSpeakerIcon.svg"}
                    alt="speaker"
                    className="w-10 h-10"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="h-full w-full flex items-center justify-center px-2"> 
            <img src="/Assets/Images/PwaInstall.png" alt="pwa install" className="w-full h-full" />
        </div>
        <div className="text-center text-2xl font-bold m-4">
        {pwaInstallHeading[selectedLanguage]}
        </div>
        <div className="flex flex-col gap-2 items-center justify-center px-4">
            <NextBtn
            value={pwaInstallButton[selectedLanguage]}
            icon="/Assets/Images/Install.svg"
            bgColor="var(--green-5)"
            color="var(--neutral-white)"
            leftIcon={true}
            btnFullWidth={true}
            textCenter={true}
            nextClick={handleInstallPwa}
            />
            <NextBtn
            value={pwaInstallCancel[selectedLanguage]}
            bgColor="var(--neutral-white)"
            color="var(--dark-neutral-2)"
            showIcon={false}
            btnFullWidth={true}
            textCenter={true}
            nextClick={handleSkipInstall}
            />
        </div>
      </div>
      {showToastMessage && (
          <ToastMessage
            message={toastErrorMessage}
            severity={ToastSeverityMap.error}
            direction={"bottom"}
            close={setShowToastMessage}
          />
        )}
    </div>
  );
};

export default PwaInstall;
